import unit from "./unit.json";
import tag from "./tag.json";
import brand from "./brand.json";
import vendor from "./vendor.json";
import category from "./category.json";
import attribute from "./attribute.json";
import displayOrder from "./displayOrder.json";
import product from "./product";

// One JSON per screen in the Product Management module; this barrel assembles
// them into the single `productManagement` i18n namespace. Add a screen by
// dropping in its JSON and adding it here — src/i18n/index.ts stays untouched.
const productManagement = {
  unit,
  tag,
  brand,
  vendor,
  category,
  attribute,
  displayOrder,
  product,
};

export default productManagement;
